import React, { useMemo } from 'react';
import { APITypes } from '../../../../../../../primary-record-types';
import { Form } from '../../../../../../v2BaseComponents/Form';
import { handleFormikSubmit } from '../../../../../../../utils/handleFormikSubmit';
import SideDrawerFormContainer, {
    ConfirmDirtyStateFormCloseContainer,
    SideDrawerDirtyFormExitValidationTracker,
} from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import FormFields, {
    mapFormValuesToRequest,
    FormValue,
    mapInvitationDefinitionToFormValues,
} from '../../../../../../shared/InvitationDefinitions/FormFields';

export type EditInvitationDefinitionFormOwnProps = {
    invitationDefinition: APITypes.organizationService.GetInvitationDefinitionResponse;
    onUpdate: (InvitationDefinition: APITypes.organizationService.UpdateInvitationDefinitionRequest) => void;
    isDisabled: boolean;
    onCancel: () => void;
};

export type EditInvitationDefinitionFormProps = EditInvitationDefinitionFormOwnProps;

const EditInvitationDefinitionForm: React.FC<EditInvitationDefinitionFormProps> = (props) => {
    const initialValues = useMemo<FormValue>(
        () => mapInvitationDefinitionToFormValues(props.invitationDefinition),
        [props.invitationDefinition],
    );

    return (
        <ConfirmDirtyStateFormCloseContainer>
            <Form
                initialValues={initialValues}
                onSubmit={(values, helpers) => {
                    props.onUpdate(mapFormValuesToRequest(values));
                    handleFormikSubmit(values, helpers);
                }}
                isDisabled={props.isDisabled}
                onCancel={props.onCancel}
                fillContainer
                forceStackFields
            >
                {({ isSubmitting, handleSubmit, values }) => (
                    <SideDrawerFormContainer
                        isDisabled={props.isDisabled || isSubmitting}
                        onSubmit={handleSubmit}
                        onCancel={props.onCancel}
                    >
                        <SideDrawerDirtyFormExitValidationTracker />
                        <FormFields isDisabled={props.isDisabled} value={values} initialValues={initialValues} />
                    </SideDrawerFormContainer>
                )}
            </Form>
        </ConfirmDirtyStateFormCloseContainer>
    );
};

export default React.memo(EditInvitationDefinitionForm);
